import { Chip } from '@mui/material';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const AdminPoliciesPage = () => {
  const columns = [
    { key: 'name', label: 'Policy' },
    { key: 'family', label: 'Family' },
    {
      key: 'is_default',
      label: 'Default',
      render: (row) =>
        row.is_default ? (
          <Chip size="small" label="Default" sx={{ bgcolor: 'rgba(59,130,246,0.12)', color: '#1d4ed8', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="No" />
        )
    },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    },
    {
      key: 'updated_at',
      label: 'Updated',
      render: (row) => (row.updated_at ? new Date(row.updated_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'name', label: 'Policy Name', type: 'text', grid: 6 },
    {
      name: 'family',
      label: 'Family',
      type: 'select',
      grid: 6,
      defaultValue: 'global',
      options: [
        { value: 'global', label: 'Global' },
        { value: 'web', label: 'Web' },
        { value: 'network', label: 'Network' },
        { value: 'mobile', label: 'Mobile' }
      ]
    },
    { name: 'is_default', label: 'Default Policy', type: 'switch', grid: 6, defaultValue: false },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 6, defaultValue: true },
    { name: 'config', label: 'Policy Config (JSON)', type: 'json', grid: 12, defaultJson: {} }
  ];

  return (
    <AdminResourceCrudPage
      title="Scan Policies"
      subtitle="Define scan-family policies and secure default execution options."
      icon={PolicyOutlinedIcon}
      endpoint="/api/admin/policies/"
      columns={columns}
      fields={fields}
    />
  );
};

export default AdminPoliciesPage;
